export const CAROUSEL_TYPES = {
  Academies: "Academies",
  Jobs: "Jobs",
  Courses: "Courses",
  ContinueLearning: "ContinueLearning",
  SkillGoals: "SkillGoals",
  JobOfInterest: "JobOfInterest",
};
